export default __webpack_public_path__ + "static/media/log-action-icon.66d0102a.svg";